<mat-label *ngIf="form.controls.activity.value > 0" class="mx-1 my-2 text-white" style="margin-bottom: 10px;">Validity Check</mat-label>
<div class="card dark-mode  card-bg p-2 mb-3" *ngIf="form.controls.activity.value > 0">
    <div class="card dark-mode dark-bg text-white activity mb-3 px-3">
        <b class="mt-3 mx-2" style="margin-bottom: 10px;">Activity: {{activity.activityType}}x</b>
        <div class="condition m-2" *ngFor="let condition of activity.conditions; let j = index">

            <div class="" *ngIf="condition.conditionType.toUpperCase() == 'BOOLEAN'">
                <div class="condition-question text-color-black-normal-50">{{condition.conditionName}} *</div>
                <mat-radio-group
                        required
                        [disabled]="uploading"
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="activity.conditions[j].answer"
                        style="margin-left: -10px;">
                    <mat-radio-button [value]="'true'">Yes</mat-radio-button>
                    <mat-radio-button [value]="'false'">No</mat-radio-button>
                </mat-radio-group>

            </div>
            <div class="" *ngIf="condition.conditionType.toUpperCase() == 'INTEGER'">
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>{{condition.conditionName}}x</mat-label>
                    <input
                            required
                            [disabled]="uploading"
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="activity.conditions[j].answer"
                            class="text-end"
                            type="number"
                            matInput>
                </mat-form-field>

            </div>
        </div>
        <div class="mx-2 pt-3" style="border-top: 1px solid #ccc;">
            <b class="mt-3 mb-3" style="margin-bottom: 10px;">Activity Completion Question</b>
            <mat-form-field class="w-100 mt-3" appearance="outline">
                <mat-label>{{activity.completionQuestion}}</mat-label>
                <input
                        required
                        [disabled]="uploading"
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="activity.completionQuestionAnswer"
                        class="text-end"
                        type="number"
                        matInput>
                <span matSuffix class="mx-2">{{activity.unitBase}}</span>
            </mat-form-field>

        </div>
    </div>

    <div *ngIf="summary" class="card dark-bg mb-2 px-4 pb-2 text-white">
        <b class="mt-3" style="margin-bottom: 10px;">Summary</b>
        <div class="condition-question mt-2">
            {{summary}}
        </div>

    </div>
    <div class="condition-question px-4 pb-2 mb-2 mt-2 text-center">
        <span class="accent-orange button-flat" (click)="getSummary()">Get Summary</span>
    </div>
</div>
